import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

function useDistricts(provinceId) {
  const [districts, setDistricts] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    async function fetchAll() {
      try {
        const provinces = await dataProvider.getList("districts", {
          filter: { province_id: provinceId },
        });
        setDistricts(provinces.data);
        return setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [provinceId]);

  return {
    districts,
    loading,
    error,
  };
}

export default useDistricts;
